import SC from "./style";
import { useState, useEffect } from "react";
import { apiPost } from "api/callApi";
import { Button, Label, Loader } from "InnoUI/components";
import theme from "theme";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
import InnoIcons from "InnoUI/innoicons";
import { regexTypes, validateEmail, validtionMessages } from "utils/config";
import { genderOption, nameTitle, sendCedential } from "utils/optionData/utils";
import { CompanyDropdown, CountryCodeDropdown, InputField } from "components";
import { decryptCrypto, showAlert } from "utils/helper";

function AddEditUser(props) {
  const {
    onClose = () => {},
    userdata,
    isEditing,
    fetchData = () => {},
    companyId,
    setCurrentPage = () => {},
    isDisabled = false,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    gender: "2",
    title: "0",
    sendUserCredential: "0",
    telCode: "+27",
    cellCode: "+27",
    // faxCode: "+27",
    adminStatus: false,
    isGoogleSignIn: false,
    companyId: companyId,
  });
  const [errorKeys, setErrorKeys] = useState({
    userName: false,
    email: false,
    secondaryEmail: false,
  });

  // Set initial data based on editing state
  useEffect(() => {
    if (isEditing) {
      const newData = { ...userdata };
      newData.cell = decryptCrypto(newData.cell);
      newData.tel = decryptCrypto(newData.tel);
      if (userdata.userType === 2) {
        newData.adminStatus = false;
        // newData.telCode = null;
      } else {
        newData.adminStatus = true;
      }
      setData(newData);
    }
  }, [isEditing, userdata]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Function to actually submit the form
    const submitForm = async () => {
      const formData = {
        ...data,
        userName: data.email,
      };

      if (!validateEmail(data.email)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, email: true }));
        return;
      }
      if (data.secondaryEmail && !validateEmail(data.secondaryEmail)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, secondaryEmail: true }));
        return;
      }

      setErrorKeys({
        email: false,
        secondaryEmail: false,
      });

      setLoading(true);
      try {
        const endpoint = isEditing
          ? `/v1/edituser/${userdata.id}`
          : `/v1/adduser`;
        const response = await apiPost(endpoint, formData);
        setLoading(false);
        showAlert({
          title: "Success",
          text: response?.message,
          icon: "success",
        });
        await fetchData();
        if (setCurrentPage) {
          setCurrentPage(1);
          await fetchData();
        }
        onClose();
      } catch (error) {
        console.error("Error:", error);
        showAlert({
          title: "error",
          text: error.response?.data?.message || "An error occurred",
          icon: "error",
        });
        setLoading(false);
      }
    };

    // Check Admin Status before submitting using SweetAlert
    if (!isDisabled && data.adminStatus == true) {
      showAlert({
        title: "Confirm Admin Access",
        text: "You are granting Admin access at the global level. Are you sure you want to proceed?",
        icon: "warning",
        buttons: ["Cancel", "Confirm"],
      }).then((isConfirm) => {
        if (isConfirm) {
          submitForm();
        }
      });
    } else {
      submitForm();
    }
  };

  const handleChange = (property, value, selectedCompanyd) => {
    if (property === "email" || property === "secondaryEmail") {
      if (!validateEmail(value)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: true }));
      } else {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: false }));
      }
    }
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          {isEditing ? "Edit User" : "New User"}
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>
      {loading && <Loader />}
      <SC.Form onSubmit={handleSubmit}>
        <SC.FormWrapper>
          <SC.LabelContainer>
            <SC.Label>
              Full Name <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <SC.Select
                  name="title"
                  value={data.title}
                  onChange={(e) => handleChange("title", e.target.value)}
                  style={{
                    height: "29px",
                    marginRight: "5px",
                    fontSize: "11px",
                  }}
                >
                  {nameTitle.map((title) => (
                    <option key={title.id} value={title.id}>
                      {title.label}
                    </option>
                  ))}
                </SC.Select>

                <InputField
                  name="fullName"
                  value={data.fullName}
                  onChange={handleChange}
                  style={{ width: "72%", height: "29px" }}
                  required
                  regexType={regexTypes.textOnly}
                  // capitalize={true}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          {/* Gender Radio Group */}
          {/* <Label label="Gender">
            <RadioGroup
              row
              name="gender"
              value={data?.gender}
              onChange={(e) => handleChange("gender", e.target.value)}
            >
              {genderOption.map((option) => (
                <FormControlLabel
                  key={option.id}
                  value={option.id}
                  control={
                    <Radio
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                        "&.Mui-checked": {
                          color: "#EC810B",
                        },
                        margin: "0px 0px 0px 10px",
                      }}
                    />
                  }
                  label={option.label}
                />
              ))}
            </RadioGroup>
          </Label> */}

          {/* Email Inputs */}

          <SC.LabelContainer>
            <SC.Label>
              Email (Default) <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <InputField
                name="email"
                value={data.email}
                onChange={handleChange}
                required
                disabled={isEditing}
                type="email"
              />

              {errorKeys.email && (
                <SC.ValidtionMessages>
                  {validtionMessages.email}
                </SC.ValidtionMessages>
              )}
            </SC.Children>
          </SC.LabelContainer>

          <Label label="Email (Secondary)">
            <InputField
              name="secondaryEmail"
              value={data.secondaryEmail}
              onChange={handleChange}
              type="email"
            />

            {errorKeys.secondaryEmail && (
              <SC.ValidtionMessages>
                {validtionMessages.email}
              </SC.ValidtionMessages>
            )}
          </Label>

          {/* Cell Input */}

          <SC.LabelContainer>
            <SC.Label>
              Cell <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper style={{ display: "flex", gap: "10px" }}>
                <CountryCodeDropdown
                  name="cellCode"
                  defaultValue={data.cellCode}
                  onChange={handleChange}
                />

                <InputField
                  name="cell"
                  value={data.cell}
                  onChange={handleChange}
                  required
                  type="number"
                  style={{ width: "55.5%", height: "29px" }}
                  maxLength={15}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          <Label label="Tel (Secondary)">
            <SC.Wrapper style={{ gap: "10px" }}>
              <CountryCodeDropdown
                name="telCode"
                defaultValue={data?.telCode || "+27"}
                onChange={handleChange}
              />

              <InputField
                name="tel"
                value={data.tel}
                onChange={handleChange}
                type="number"
                style={{ width: "55.5%", height: "29px" }}
                maxLength={15}
              />
            </SC.Wrapper>
          </Label>

          {/* Company Name */}
          <Label label="Company Name">
            <CompanyDropdown
              name="companyId"
              onChange={handleChange}
              defaultValue={data?.companyId || undefined}
              newItemLabel={"+ New Company"}
              setSelectedCompany={(value) => {
                handleChange("companyId", value);
              }}
              disabledDropdown={companyId}
            />
          </Label>

          {/* Send Credentials Option */}
          {!isEditing && (
            <Label label="Send user credentials on user creation">
              <RadioGroup
                row
                name="sendUserCredential"
                value={data?.sendUserCredential || ""}
                onChange={(e) =>
                  handleChange("sendUserCredential", e.target.value)
                }
              >
                {sendCedential.map((option) => (
                  <FormControlLabel
                    key={option.id}
                    value={option.id}
                    control={
                      <Radio
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 16,
                          },
                          "&.Mui-checked": {
                            color: "#EC810B",
                          },
                          margin: "0px 0px 0px 10px",
                        }}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </RadioGroup>
            </Label>
          )}

          {/* Username Input */}
          <SC.LabelContainer>
            <SC.Label>
              Username <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <InputField
                name="userName"
                //value={data.userName}
                value={data.email}
                onChange={handleChange}
                required
                disabled={true}
              />

              {errorKeys.userName && (
                <SC.ValidtionMessages>
                  {validtionMessages.username}
                </SC.ValidtionMessages>
              )}
            </SC.Children>
          </SC.LabelContainer>

          {/* Admin Status Switch */}
          {!isDisabled && (
            <Label label="Admin Status">
              <Switch
                checked={data.adminStatus}
                onChange={(e) => handleChange("adminStatus", e.target.checked)}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Label>
          )}
          <Label label="Google Login">
            <Switch
              checked={data.isGoogleSignIn}
              onChange={(e) => handleChange("isGoogleSignIn", e.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Label>

          {/* Buttons */}
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              onClick={onClose}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
            <Button
              caption={isEditing ? "Save" : "Add"}
              type="submit"
              isLoading={loading}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
            />
          </SC.ButtonContainer>
        </SC.FormWrapper>
      </SC.Form>
    </>
  );
}

export default AddEditUser;
